"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerFeedbackTable = _interopRequireDefault(require("./CustomerFeedbackTable.vue"));
var _StopContractTable = _interopRequireDefault(require("./StopContractTable.vue"));
var _TransferTable = _interopRequireDefault(require("./TransferTable.vue"));
var _transferSoon = require("@/api/transferSoon.api");
var TransferTab = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(TransferTab, _Vue);
  var _super = (0, _createSuper2.default)(TransferTab);
  function TransferTab() {
    var _this;
    (0, _classCallCheck2.default)(this, TransferTab);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    return _this;
  }
  (0, _createClass2.default)(TransferTab, [{
    key: "handleQuery",
    value: function handleQuery() {
      this.query.page = 1;
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.loading = true;
                _context.next = 4;
                return _transferSoon.transferSoonApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), {}, {
                  buildingId: this.buildingId
                }));
              case 4:
                res = _context.sent;
                this.data = res.data.formTransferSoons;
                this.total = res.data.total;
              case 7:
                _context.prev = 7;
                this.loading = false;
                return _context.finish(7);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 7, 10]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return TransferTab;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], TransferTab.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("buildingId", {
  immediate: true
})], TransferTab.prototype, "handleQuery", null);
TransferTab = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerFeedbackTable: _CustomerFeedbackTable.default,
    StopContractTable: _StopContractTable.default,
    TransferTable: _TransferTable.default
  }
})], TransferTab);
var _default = TransferTab;
exports.default = _default;